// Admin-only floating "Edit this page" button — appears on public pages when logged in as admin/trainer.
// Maps the current pathname → the editable page slug used by the existing block editor.
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PencilSimple } from "@phosphor-icons/react";

const PATH_TO_SLUG = {
  "/": "home",
  "/about": "about",
  "/services": "services",
  "/faq": "faq",
  "/contact": "contact",
  "/tips": "tips",
  "/service-areas": "service-areas",
};

export default function AdminInlineEditButton() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || (user.role !== "admin" && user.role !== "trainer")) return null;
  // Only show on pages that have an editable slot
  const slug = PATH_TO_SLUG[pathname];
  if (!slug) return null;
  return (
    <Link
      to="/admin/pages"
      state={{ slug }}
      data-testid="admin-edit-this-page"
      className="fixed bottom-24 right-6 z-[55] bg-[#1b4a76] hover:bg-[#143a5e] text-white rounded-full shadow-2xl px-4 py-3 inline-flex items-center gap-2 text-sm font-semibold transition-transform hover:scale-105"
      title={`Edit /${slug === "home" ? "" : slug}`}
    >
      <PencilSimple size={18} weight="bold" />
      <span className="hidden sm:inline">Edit this page</span>
    </Link>
  );
}
